import { render, staticRenderFns } from "./homeWidget.vue?vue&type=template&id=0c6f353e&scoped=true"
import script from "./homeWidget.vue?vue&type=script&lang=js"
export * from "./homeWidget.vue?vue&type=script&lang=js"
import style0 from "./homeWidget.vue?vue&type=style&index=0&id=0c6f353e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f353e",
  null
  
)

export default component.exports